export const checkProfileCompletionRedirect = (userStore, currentPath) => {
  return (
    !userStore.isProfileComplete &&
    userStore.profileId &&
    !currentPath.includes("/my/profile")
  );
};
